import React, { useEffect, useState } from 'react';
import firebase, { firebaseAnalytics }  from './Firebase';
import { FontAwesomeIcon  } from '@fortawesome/react-fontawesome';
import { faBitcoin, faCcPaypal } from '@fortawesome/free-brands-svg-icons';
import { Accordion, AccordionToggle, Card, AccordionCollapse, Table, Spinner } from "react-bootstrap";

export default function Merch() {  
    const [wallets, setWallets] = useState([])
    const [loading, setLoading] = useState(true);  

    var test = [
        {
            coin: "Bitcoin",
            address: "btc19erfjirjsgij8fi59tj50"
        },
        {
            coin: "Ethereum",
            address: "0xdfjruin2r93r902f0if9043"
        },
        {
            coin: "USDT(TR20)",
            address: "0xcrgqei3jip5jf45g9240g"
        },
        {
            coin: "LUNA/UST",
            address: "terra1iej39rj4f034f3k0f"
        },
    ]

    const ref = firebase.firestore().collection("crypto");
    
    useEffect(() => {
        firebaseAnalytics.logEvent("merch_tab_visited");
        firebaseAnalytics.setCurrentScreen("merch_tab")
        setLoading(true);
        ref.get().then((query)  => { updateState(query)})
        .catch(err=> console.error(err));
        setLoading(false)
        
    }, []);

    const updateState = query => {
        var items = [];
        
        query.forEach(doc => {items = doc.data()});
        setWallets(items.wallet)
        setLoading(false);
    }

    const renderWallet = wallet => {
       
        return (
                <>
                    <text style={{justifyContent: "left" }}>
                        <div >
                            <text style={{color: "#2c2c32", fontWeight: "bold"}} > 
                                {wallet.coin}
                            </text>
                        </div>
                        <text style={{color: "#2c2c32", fontSize: "14px", cursor: "pointer"}} onClick={() => {navigator.clipboard.writeText(wallet.address)}}> 
                                {wallet.address}
                            </text>
                    </text>
                    {<hr/>}
                </>
        )
    }

  return (
    <div style={{color: "white"}}>
        
        <h2>Coming soon</h2>
        
        <hr/>
        <text>
            Il Merch è in sviluppo... se apprezzi il nostro lavoro puoi supportarci donando:
        </text>
        <br/> <br/> <br/>


        <div className='row' style={{justifyContent: "center"}}>
            <div className="row" style={{marginInline: "2%", cursor:"pointer", alignSelf: "center"}} onClick={ ()=> window.open("https://www.paypal.me/Filosofinerba", "_blank")}>
                <div style={{alignSelf: "end", marginInline: "10px"}}>
                    PayPal 
                </div>
                <FontAwesomeIcon size='3x' icon={faCcPaypal} color="lightsteelblue"/>
            </div>
            <div style={{marginInline: "2%", alignSelf: "end"}}>
                /
            </div>
            
            <Accordion style={{ borderRadius: "10px"}} >
                <Card style={{width: "100%", borderWidth: "0px", backgroundColor: "#2c2c32" }}>
                    <AccordionToggle  class="testo-risposte" as={Card.Header} eventKey="crypto"  style={{marginBottom: "2%"}}>    
                        <div style={{fontSize: 15, color: "white", cursor: "pointer"}}>
                            Crypto <FontAwesomeIcon size='3x' icon={faBitcoin} color="orange"/>
                        </div>
                    </AccordionToggle>
                    <AccordionCollapse eventKey="crypto" style={{ borderRadius: "0px 0px 10px 10px", backgroundColor: "rgb(194, 194, 194)"}}>
                        <Card.Body >
                        {
                            loading ?
                            <h2 style={{ color: 'white' }}>
                                <Spinner animation="grow" />
                            </h2>
                            :
                            <div>
                                {wallets.map(w => {return renderWallet(w)} )}
                            </div>
                        }
                        </Card.Body>
                    </AccordionCollapse>
                </Card>
            </Accordion>
        </div>


        <br/> <br/>
        <text>Grazie❤️</text>
    </div>
  )
}